/** Queries for 'Region' */

import { tag } from 'api/rtkTags'
// eslint-disable-next-line
import { initialRegion } from 'constants/initialValues'
import { label } from 'constants/labels'

export const queryGetPagedRegion = (pageNumber, pageSize, options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'page',
      type: 'region',
      data: {
        pageNumber,
        pageSize,
        options
      }
    },
    providesTags: {
      type: tag.region
    }
  }
}

export const queryGetAllRegion = (options = {}) => {
  return {
    query: {
      name: 'data',
      mode: 'all',
      type: 'region',
      data: { options }
    },
    providesTags: {
      type: tag.region
    }
  }
}
/**
 * @param {initialRegion} data
 */
export const queryAddRegion = data => {
  return {
    query: {
      name: 'data',
      mode: 'new',
      type: 'region',
      data: { values: data }
    },
    invalidatesTags: [tag.region],
    successMsg: label.successMsgCreate + ' ' + label.msgRegion
  }
}

/**
* @param {initialRegion} data
@param {string} id
*/
export const queryUpdateRegion = (data, id) => {
  return {
    query: {
      name: 'data',
      mode: 'update',
      type: 'region',
      data: {
        values: data,
        options: {
          where: {
            id
          }
        }
      }
    },
    invalidatesTags: [tag.region],
    successMsg: label.successMsgEdit + ' ' + label.msgRegion
  }
}
/**
@param {string} id
*/
export const queryDeleteRegion = id => {
  return {
    query: {
      name: 'data',
      mode: 'delete',
      type: 'region',
      data: {
        options: {
          where: { id }
        }
      }
    },
    invalidatesTags: [tag.region],
    successMsg: label.successMsgDelete + ' ' + label.msgRegion
  }
}
